import { render, staticRenderFns } from "./feedPost.vue?vue&type=template&id=564d4f42&"
import script from "./feedPost.vue?vue&type=script&lang=js&"
export * from "./feedPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports